import React, { useState } from 'react';
import { Box, Button, Form, FormField, Heading, TextInput } from 'grommet';
import axios from 'axios';
import {Link} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";


function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    function handleSubmit(event) {
        event.preventDefault();

        axios.post(process.env.REACT_APP_BASE_API_URL + 'forgot_password/', {
            email,
        })
            .then(response => {
                toast.success('Richiesta inviata correttamente!', {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                //window.location.href = '/webapp/';
            })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <Box align="center" pad="medium">
            <Heading level={1}>Password dimenticata</Heading>
            {successMessage && <Box background="status-ok" pad="medium" margin={{ bottom: 'medium' }}>{successMessage}</Box>}
            {errorMessage && <Box background="status-error" pad="medium" margin={{ bottom: 'medium' }}>{errorMessage}</Box>}
            <Form onSubmit={handleSubmit}>
                <FormField name="email" label="Email">
                    <TextInput type="email" value={email} onChange={event => setEmail(event.target.value)} />
                </FormField>
                <Button type="submit" label="Invia" primary />
                <Link to="/">
                    <Button label="Torna al login" />
                </Link>
            </Form>
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Box>
    );
}

export default ForgotPassword;
